export enum DefaultThemeColors {
    Primary = 'primary',
    Secondary = 'secondary',   
    Success = 'success',
    Info = 'info',
    Warning = 'warning',
    Danger = 'danger'
}

export enum SystemColors {
    DisabledGray = "#ced4da"
}

export enum AvatarColors {
    Red = "#f09292",
    Orange = "#f2be80",
    Yellow = "#ecd79c",
    Green = "#92c489",
    Cyan = "#8ccbda",
    Blue = "#8f9fe2",
    Purple = "#b4a8e9"
}

export enum InvoiceFeePayerColors {
    MemberPaid = "#198754",
    OrganizationPaid = "#00aeef"
}

export enum ModalActions {
    Show = "show",
    Hide = "hide",
    Toggle = "toggle",
    Dispose = "dispose"
}

export enum DropdownActions {
    Show = "show",
    Hide = "hide",
    Toggle = "toggle",
    Dispose = "dispose"
}

export enum AddressPipeSecondaryAddressFormat {
    Inline = "Inline",
    NewLine = "NewLine",
    None = "None"
}

// Html suits an innerHTML binding; Text suits plain-text sinks such as a tooltip or title attribute.
export enum AddressPipeLineSeparator {
    Html = "<br/>",
    Text = "\n"
}

export enum PropertyListViewLocations {
    PropertyListPage = "PropertyListPage",
    MemberProfilePage = "MemberProfilePage",
    AddPropertyToMemberModal = "AddPropertyToMemberModal"
}

export enum PropertyChargeListViewLocations {
    PropertyChargeScheduleSummaryPage = "PropertyChargeScheduleSummaryPage",
    PropertyProfilePage = "PropertyProfilePage",
    MemberProfilePage = "MemberProfilePage",
    InvoiceDashboardPage = "InvoiceDashboardPage"
}

// Why a paid invoice cannot be voided yet. Unknown is the lookup failing, which is not the same as
// the lookup finding nothing — that is a legacy or imported invoice, and means Unmark.
export enum VoidBlockReason {
    Refund = "Refund",
    Unmark = "Unmark",
    Unknown = "Unknown"
}

// The two renderings every list ships: a table, and the card stack that replaces it on small screens.
// Their rows differ several-fold in height, so measurements are recorded against the layout they came
// from rather than the list alone.
export enum ListLayouts {
    Table = "table",
    Cards = "cards"
}

export enum PaymentHistoryListViewLocations {
    PropertyProfilePage = "PropertyProfilePage",
    MemberProfilePage = "MemberProfilePage",
    OrganizationPaymentsHistoryPage = "OrganizationPaymentsHistoryPage"
}

export enum SentEmailListViewLocations {
    OrganizationCommunicationsPage = "OrganizationCommunicationsPage",
    MemberProfilePage = "MemberProfilePage"
}

export enum MemberListViewLocations {
    MemberListPage = "MemberListPage",
    PropertyProfilePage = "PropertyProfilePage",
    AddMemberToPropertyModal = "AddMemberToPropertyModal",
    TransferOrganizationOwnershipModal = "TransferOrganizationOwnershipModal",
    ManageOrganizationAdminsModal = "ManageOrganizationAdminsModal"
}

// How the address verification dialog presents a result: the provider's verdict crossed with
// whether, and how far, it corrected what was entered. A Deliverable address that needed no
// correction never reaches the dialog at all.
export enum AddressVerificationOutcome {
    ZipExtensionAdded = "ZipExtensionAdded",
    Corrected = "Corrected",
    DeliverableWithIssues = "DeliverableWithIssues",
    Undeliverable = "Undeliverable"
}

// Which side of a verification the user picked. Standardized yields a Verified address with a
// geocode where the provider has one; Original yields UserEntered with none.
export enum AddressVerificationChoice {
    Original = "Original",
    Standardized = "Standardized"
}

export enum ModalTypes {
    Success = "success",
    Failure = "failure",
    Question = "question",
    Exclamation = "exclamation",
    Information = "information"
}

export enum AuditEntityType {
  User = 'USER',
  Property = 'PROPERTY',
  Member = 'MEMBER',
  Organization = 'ORGANIZATION',
  PropertyChargeSchedule = 'PROPERTY_CHARGE_SCHEDULE',
  PropertyCharge = 'PROPERTY_CHARGE',
  Budget = 'BUDGET',
  DocumentCenter = 'DOCUMENT_CENTER',
  ChartOfAccount = 'CHART_OF_ACCOUNT',
  /** Reconciliation actions on one connected bank account: matches, transfers, exclusions and undos. */
  BankConnection = 'BANK_CONNECTION'
}

export enum StripeFormMode {
    Setup = 'setup',
    Payment = 'payment',
    Collect = 'collect'
}

export enum SystemMessages {
  None = "",
  Unauthorized = "401",
  Forbidden = "403",
  PageNotFound = "404",
  ServerError = "500",
  InvitationError = "invitation-error",
  AuthError = "auth-error",
  Maintenance = "maintenance",
  AccountDeactivated = "account-deactivated"
}

// Keys that move focus along a tab strip, per the ARIA tabs pattern.
export enum TabNavigationKeys {
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    ArrowUp = 'ArrowUp',
    ArrowDown = 'ArrowDown',
    Home = 'Home',
    End = 'End'
}
